var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 33.5C6.5 26.8725 11.8726 21.5 18.5 21.5C25.1275 21.5 30.5 26.8725 30.5 33.5H27.5C27.5 28.5294 23.4706 24.5 18.5 24.5C13.5294 24.5 9.5 28.5294 9.5 33.5H6.5ZM18.5 20C13.5275 20 9.5 15.9725 9.5 11C9.5 6.0275 13.5275 2 18.5 2C23.4725 2 27.5 6.0275 27.5 11C27.5 15.9725 23.4725 20 18.5 20ZM18.5 17C21.815 17 24.5 14.315 24.5 11C24.5 7.685 21.815 5 18.5 5C15.185 5 12.5 7.685 12.5 11C12.5 14.315 15.185 17 18.5 17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLine);
export default __webpack_public_path__ + "static/media/user-line.b556c8f15494f8735368ef12485ad441.svg";
export { ForwardRef as ReactComponent };